<h2 mat-dialog-title translate="CALLS.EXTEND_RETENTION.HISTORY_TITLE"></h2>
<mat-dialog-content>
  <p class="call-name mask-call-name">{{ data.callName }}</p>
  @if (extensions$ | async; as result) {
    @if (result.isLoading) {
      <app-spinner></app-spinner>
    } @else if (result.isError) {
      <p>{{ 'COMMON.ERROR_LOADING_DATA' | translate }}</p>
    } @else if (result.data && result.data.length > 0) {
      <table class="history">
        <thead>
          <tr>
            <th translate="CALLS.EXTEND_RETENTION.HISTORY_EXTENDED_BY"></th>
            <th translate="CALLS.EXTEND_RETENTION.HISTORY_EXTENDED_AT"></th>
            <th translate="CALLS.EXTEND_RETENTION.HISTORY_REQUESTED_BY"></th>
            <th translate="CALLS.EXTEND_RETENTION.HISTORY_PREVIOUS_SOFT_DELETION_DATE"></th>
            <th translate="CALLS.EXTEND_RETENTION.HISTORY_SOFT_DELETION_DATE"></th>
            <th translate="CALLS.EXTEND_RETENTION.HISTORY_PREVIOUS_DELETION_DATE"></th>
            <th translate="CALLS.EXTEND_RETENTION.HISTORY_DELETION_DATE"></th>
          </tr>
        </thead>
        <tbody>
          @for (extension of result.data; track extension.id) {
            <tr>
              <td [attr.data-label]="'CALLS.EXTEND_RETENTION.HISTORY_EXTENDED_BY' | translate">{{ extension.extendedByName }}</td>
              <td [attr.data-label]="'CALLS.EXTEND_RETENTION.HISTORY_EXTENDED_AT' | translate">{{ extension.createdAt | date: dateTimeFormat }}</td>
              <td [attr.data-label]="'CALLS.EXTEND_RETENTION.HISTORY_REQUESTED_BY' | translate">{{ extension.requestedByName ?? '-' }}</td>
              <td [attr.data-label]="'CALLS.EXTEND_RETENTION.HISTORY_PREVIOUS_SOFT_DELETION_DATE' | translate">
                {{ extension.previousSoftDeletionDate === null ? '-' : (extension.previousSoftDeletionDate | date: dateTimeFormat) }}
              </td>
              <td [attr.data-label]="'CALLS.EXTEND_RETENTION.HISTORY_SOFT_DELETION_DATE' | translate">
                {{ extension.softDeletionDate === null ? '-' : (extension.softDeletionDate | date: dateTimeFormat) }}
              </td>
              <td [attr.data-label]="'CALLS.EXTEND_RETENTION.HISTORY_PREVIOUS_DELETION_DATE' | translate">
                {{ extension.previousDeletionDate === null ? '-' : (extension.previousDeletionDate | date: dateTimeFormat) }}
              </td>
              <td [attr.data-label]="'CALLS.EXTEND_RETENTION.HISTORY_DELETION_DATE' | translate">{{ extension.deletionDate | date: dateTimeFormat }}</td>
            </tr>
          }
        </tbody>
      </table>
      <p class="local-time">{{ 'COMMON.ALL_TIMES_IN_TIME_ZONE' | translate: { timeZone: localTimeZone } }}</p>
    } @else {
      <p translate="CALLS.EXTEND_RETENTION.HISTORY_EMPTY"></p>
    }
  }
</mat-dialog-content>
<mat-dialog-actions class="actions" align="end">
  <button mat-button mat-dialog-close translate="COMMON.CLOSE"></button>
</mat-dialog-actions>
